import { render } from "./VerifyEmail.vue?vue&type=template&id=0bb2cfce"
import script from "./VerifyEmail.vue?vue&type=script&lang=js"
export * from "./VerifyEmail.vue?vue&type=script&lang=js"
script.render = render

export default script